import { AppDispatch } from 'config/redux'
import { RootState } from 'constants/interfaces'
import React, { useCallback, useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getPrompts } from 'redux/actions/promts'
import { usePromptsModals } from './PromtsModalProvider'
import { Box, Flex, PseudoBox, Text, useToast } from '@chakra-ui/core'
import { NoFocusButton } from 'components/CommonComponents/NoFocusButton'
import { Bot } from 'lucide-react'
import useLocaleText from 'components/useLocaleText'
import { PromptsTable } from './PromptsTable'

const MAX_PROMPTS = 50

export const PromtsBoardContent = () => {
  const dispatch: AppDispatch = useDispatch()
  const toast = useToast()
  const theme = useSelector((state: RootState) => state.general.theme)
  const { openPromtsModal } = usePromptsModals()
  const { prompts, isLoading } = useSelector((state: RootState) => state.prompts)

  const t_prompts = useLocaleText('prompts', true)
  const create_new_prompt = useLocaleText('prompt_create', true)

  const loadPrompts = useCallback(() => {
    dispatch(getPrompts())
  }, [dispatch])

  const handleCreatePrompt = () => {
    if (prompts.length >= MAX_PROMPTS) {
      toast({
        title: `Max prompts reached. You can create up to ${MAX_PROMPTS} prompts.`,
        status: 'error',
        position: 'top-right',
      })
      return
    }
    openPromtsModal()
  }

  const sortedPrompts = useMemo(() => {
    return prompts.sort((a, b) => b.created_at_ts - a.created_at_ts)
  }, [prompts])

  useEffect(() => {
    loadPrompts()
  }, [loadPrompts])

  return (
    <Box>
      <Flex justify="space-between" align="center" mb={4}>
        <Flex align="center" style={{ gap: '10px' }}>
          <Text fontSize="2xl" fontWeight="bold">
            {t_prompts}
          </Text>
          <PseudoBox as="button" onClick={loadPrompts} color={theme?.elementsColor} _hover={{ cursor: 'pointer' }}>
            <Bot size={20} />
          </PseudoBox>
        </Flex>
        <NoFocusButton
          w="max-content"
          maxWidth="200px"
          bg={theme?.elementsColor}
          color="white"
          rounded="md"
          background={theme?.elementsColor}
          onClick={handleCreatePrompt}
          style={{ gap: '5px' }}
          _hover={{ opacity: 0.8 }}
        >
          <Text fontSize="14px">{create_new_prompt}</Text>
        </NoFocusButton>
      </Flex>

      <PromptsTable prompts={sortedPrompts} loading={isLoading} />
    </Box>
  )
}
